import { Navigate, useParams } from 'react-router'

/**
 * Redirects the retired Bookings > Menus routes into Ordering.
 *
 * Menus, Items and Modifier Groups lived under Bookings when Zion owned the
 * catalogue. Every organisation now reads and writes its catalogue in Mouse,
 * where a menu is sections of products and an item comes WITH its modifiers
 * from Square, so "edit this item's modifier groups" is not a thing that
 * exists any more. What was left was a read-only mirror of the Ordering menus
 * list plus two pages onto frozen Zion tables that accepted edits and changed
 * nothing anyone could see.
 *
 * A redirect rather than a 404 because staff have these bookmarked, and the
 * destination genuinely is where the work moved to.
 *
 * Square > Table Ordering (`square/ordering/*`) mounted the same Zion pages
 * and is retired the same way: it redirects here too. Whether a menu takes
 * table orders is its "Online ordering" switch in Ordering > Menus.
 *
 * The path is built from params rather than a relative `../..` so it lands
 * correctly from every depth the old subtree had (`menus`, `menus/items`,
 * `menus/modifier-categories`, `menus/:menu_id`) and from both the org-level
 * and the venue-level mount.
 */
export function MenusMovedToOrdering() {
  const { org_id: orgId = '', serial = '' } = useParams<{
    org_id: string
    serial: string
  }>()

  return (
    <Navigate
      to={
        serial
          ? `/${orgId}/venues/${serial}/ordering/menus`
          : `/${orgId}/ordering/menus`
      }
      replace
    />
  )
}

export default MenusMovedToOrdering
